import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'
import type * as subfeatures from '../subfeatures'

/**
 * Loads the user information after the user has been authenticated
 */
export const startGet = store.effects.create(
  (feature: Feature, authFeature: subfeatures.auth.Feature) =>
    authFeature.actions.authenticate.success
      .observe()
      .pipe(rxjs.map(action => feature.actions.get.from(action).create())),
)
